import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';

import Paper from '@material-ui/core/Paper';
import BucketMembersActions from './BucketMembersActions';
import Users from '../../components/users/Users';
import AppDialog from '../appDialog/AppDialog';
import Error from '../../components/Error';

import * as bucketSelectors from '../../selectors/bucketSelectors';
import * as bucketMembersSelectors from '../../selectors/bucketMembersSelectors';
import * as appDialogConstants from '../../constants/appDialog';
import { BUCKET_USER_ACTIONS } from '../../enums/UserActions';

const USER_ACTIONS = Object.keys(BUCKET_USER_ACTIONS);

const BucketMembers = props => {
    const {
        members,
        onAction,
        isAdmin,
        isAddMember,
        error,
        isLoadingMembers,
        classes,
    } = props;

    if (error) {
        return (
            <Paper square elevation={1} className={classes.wrapper}>
                <Error>
                    Could not fetch members. Please try again later or contact
                    us.
                </Error>
            </Paper>
        );
    }

    if (!members || isLoadingMembers) {
        return null;
    }

    const actions = isAdmin ? USER_ACTIONS : [];

    let memberList;
    if (!isAddMember) {
        memberList = (
            <div className={classes.members}>
                <Users users={members} actions={actions} onAction={onAction} />
            </div>
        );
    }

    return (
        <div className={classes.wrapper}>
            <BucketMembersActions />
            <div className={classes.holder}>
                <AppDialog />
                {memberList}
            </div>
        </div>
    );
};

BucketMembers.propTypes = {
    members: PropTypes.array,
    onAction: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isAddMember: PropTypes.bool.isRequired,
    error: PropTypes.string,
};

BucketMembers.defaultProps = {
    members: undefined,
    error: undefined,
};

const mapStateToProps = state => ({
    isLoadingMembers: bucketMembersSelectors.getIsLoadingMembers(state),
    members: bucketMembersSelectors.getFilteredMembers(state),
    isAdmin: bucketSelectors.getIsCurrentUserAdminForCurrentBucket(state),
    isAddMember: bucketSelectors.isAddMember(state),
    error: bucketMembersSelectors.getError(state),
});

const mapDispatchToProps = dispatch => ({
    onAction: (usersIds, action) =>
        dispatch({
            type: appDialogConstants.OPEN_ACTION_DIALOG,
            payload: {
                usersIds,
                action: BUCKET_USER_ACTIONS[action],
            },
        }),
});

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: spacing.unit * 6,
    },
    holder: {
        width: '100%',
        maxWidth: spacing.maxWidth,
    },
    members: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(BucketMembers));



// WEBPACK FOOTER //
// ./src/containers/bucketMembers/BucketMembers.js